import { render } from "./CouponsPage.vue?vue&type=template&id=4de33e78"
import script from "./CouponsPage.vue?vue&type=script&lang=js"
export * from "./CouponsPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__